<mat-card>
  @if (current | async; as lbl) {
    <div class="select-label-header flex">
      <span i18n="@@switch.label.change">Current: </span> <span> {{ lbl.name }}</span>
    </div>
  }
  @if (labels(); as labelList) {
    <mat-card-content>
      <dmb-filter
        [listItems]="labelList"
        placeholder="Search Label"
        i18n-placeholder="@@switch.label.search"
        (dataChange)="select($event)"
        (cancelled)="close()"
        allLabels></dmb-filter>
    </mat-card-content>
  }
</mat-card>
